<template>
  <el-dialog
    :visible.sync="visible"
    title="付款预览"
    width="960px"
    :close-on-click-modal="false"
    @close="onClose">
    <div v-loading="loading">
      <el-alert
        v-if="tableData.length"
        type="info"
        show-icon
        class="margin-b"
        :closable="false"
        title="最多可同时预览并付款10条记录，请确认信息后再提交。">
      </el-alert>

      <payment-center-table-list
        v-if="tableData.length"
        :data="tableData"
        :show-selection="false"
        :show-operation-column="false"
        :show-id-link="false"
        :cell-style="cellStyle"
        class="margin-b">
      </payment-center-table-list>

      <div v-if="preview" class="summary-block" :style="{ border: tableData.length ? '1px solid #ebeef5' : 'none' }">
        <div class="summary-row summary-row--layout">
          <div class="summary-fields-col">
            <div class="summary-form-line">
              <span class="summary-label-text summary-label-fixed">付款账户</span>
              <div class="summary-control-slot">
                <remote-select
                  class="summary-account-select"
                  style="width: 320px !important"
                  clearable
                  id-key="id"
                  keyword-key="name"
                  label-key="name"
                  value-key="id"
                  placeholder="请选择付款账户"
                  :value="payment_company_account_id"
                  @change="onPaymentAccountChange"
                  :query-params="companyAccountQueryParams"
                  :query-request="getCompanyAccountManagementTable"
                  :find-request="getCompanyAccountManagementDetail">
                </remote-select>
              </div>
            </div>
            <template v-if="showCorporateBankExtras">
              <div class="summary-form-line">
                <span class="summary-label-text summary-label-fixed">收款支行名称 :</span>
                <div class="summary-control-slot summary-text-slot">
                  <span class="summary-extra-value">{{ (singlePreviewRow.bank_account_snapshot && singlePreviewRow.bank_account_snapshot.bank) || '—' }}</span>
                </div>
              </div>
              <div class="summary-form-line">
                <span class="summary-label-text summary-label-fixed">收款银行全称查找</span>
                <div class="summary-control-slot">
                  <el-select
                    v-model="bankHeadquartersPick"
                    class="summary-bank-select"
                    filterable
                    remote
                    allow-create
                    default-first-option
                    clearable
                    reserve-keyword
                    :loading="bankCodeLoading"
                    :remote-method="fetchBankCodeOptions"
                    placeholder="请输入或选择收款银行全称"
                    style="width: 320px">
                    <el-option
                      v-for="item in bankHeadquartersOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </div>
          <div class="summary-right summary-right--side">
            <span>付款金额共</span>
            <span class="summary-number">{{ paidCount }}</span>
            <span>笔，合计</span>
            <span class="summary-number">¥{{ paidAmountTotal }}</span>
          </div>
        </div>
      </div>

      <div v-else-if="!loading" class="empty-state">
        <div class="empty-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="empty-text">暂无可展示的付款信息</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose" :disabled="submitting">取消</el-button>
      <el-button
        type="primary"
        :loading="submitting"
        :disabled="!canSubmit"
        @click="confirmPayment">
        确认付款
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '@core/api/request'
import PaymentCenterTableList from './PaymentCenterTableList.vue'

export default {
  name: 'PaymentPayDialog',
  components: {
    PaymentCenterTableList,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data () {
    return {
      preview: null,
      loading: false,
      submitting: false,
      payment_company_account_id: null,
      bankHeadquartersPick: '',
      bankHeadquartersOptions: [],
      bankCodeLoading: false,
      bankCodeSearchTimer: null,
    }
  },
  computed: {
    requestIds () {
      if (!this.row) {
        return []
      }
      if (Array.isArray(this.row)) {
        return this.row.map(item => item.id || item).filter(Boolean).slice(0, 10)
      }
      if (Array.isArray(this.row.ids)) {
        return this.row.ids.filter(Boolean).slice(0, 10)
      }
      if (Array.isArray(this.row.id)) {
        return this.row.id.filter(Boolean).slice(0, 10)
      }
      return this.row.id ? [this.row.id] : []
    },
    tableData () {
      return (this.preview && this.preview.data) ? this.preview.data : []
    },
    singlePreviewRow () {
      return this.tableData.length === 1 ? this.tableData[0] : null
    },
    showCorporateBankExtras () {
      const row = this.singlePreviewRow
      return !!(row && (Number(row.type) === 2 || Number(row.type) === 3))
    },
    paidAmountTotal () {
      return this.preview ? this.preview.paid_amount_total || 0 : 0
    },
    paidCount () {
      return this.preview ? this.preview.paid_count || 0 : 0
    },
    canSubmit () {
      return this.requestIds.length > 0 && !this.loading
    },
    companyAccountQueryParams () {
      const params = { is_disabled: 0 }
      // 数组是批量
      if (Array.isArray(this.row)) {
        const firstRow = this.tableData[0]
        if (firstRow && firstRow.payment_company) {
          params.our_company_id = firstRow.payment_company
        }
      } else {
        // 非数组就是单行
        params.our_company_id = this.row.payment_company
      }
      return params
    },
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetchPreview()
      } else {
        this.resetState()
      }
    },
    row: {
      handler () {
        if (this.visible) {
          this.fetchPreview()
        }
      },
      deep: true,
    },
  },
  methods: {
    ...request.map([
      'getCompanyAccountManagementTable',
      'getCompanyAccountManagementDetail',
    ]),
    onPaymentAccountChange (val) {
      this.payment_company_account_id = val.id
    },
    cellStyle (row) {
      if (row.row.is_urgent && [1, 2, 3, 4, 5, 6, 7, 11, 13, 14].includes(row.row.status * 1)) {
        return 'color:red;font-weight:bold;'
      }
      return ''
    },
    async fetchPreview () {
      // 避免同一时刻重复请求（如同时触发 visible 与 row 变更）
      if (this.loading) return
      const ids = this.requestIds
      if (!ids.length) {
        this.preview = null
        return
      }
      this.loading = true
      try {
        const { data } = await request.common('getPaymentCenterPreview', { id: ids })
        this.preview = data
        this.$nextTick(() => {
          this.syncCorporateBankFields()
        })
      } catch (error) {
        this.preview = null
        // 接口报错时关闭弹窗，拦截器已处理错误提示
        this.onClose()
      } finally {
        this.loading = false
      }
    },
    async confirmPayment () {
      const ids = this.requestIds
      if (!ids.length) {
        this.$message.error('缺少需要付款的ID')
        return
      }
      if (!this.payment_company_account_id) {
        this.$message.error('缺少付款账户信息')
        return
      }
      this.submitting = true
      try {
        const payload = {
          id: ids,
          payment_company_account_id: this.payment_company_account_id,
        }
        if (this.showCorporateBankExtras) {
          const hq = this.bankHeadquartersPick && String(this.bankHeadquartersPick).trim()
          if (hq) {
            payload.bank_fullname = hq
          }
        }
        const res = await request.common('bankPayment', payload)
        this.$message.success('付款提交成功')
        const detail = res && res.data
        if (detail && detail.is_update_bank_account) {
          const paymentId = ids[0]
          if (paymentId != null) {
            try {
              await this.$confirm('是否更新收款人银行支行信息', '提示', {
                confirmButtonText: '确认更新',
                cancelButtonText: '取消',
                type: 'info',
              })
              await request.common('updatePaymentCenterCompanyBank', paymentId)
              this.$message.success('更新成功')
            } catch (e) {
              // 取消或请求失败（失败提示由拦截器处理）
            }
          }
        }
      } catch (error) {
        // 拦截器已处理错误提示，这里仅保证完成回调触发
      } finally {
        this.$emit('finished')
        this.onClose()
        this.submitting = false
      }
    },
    onClose () {
      this.$emit('update:visible', false)
    },
    resetState () {
      this.preview = null
      this.loading = false
      this.submitting = false
      this.payment_company_account_id = null
      this.bankHeadquartersPick = ''
      this.bankHeadquartersOptions = []
      this.bankCodeLoading = false
      if (this.bankCodeSearchTimer) {
        clearTimeout(this.bankCodeSearchTimer)
        this.bankCodeSearchTimer = null
      }
    },
    syncCorporateBankFields () {
      if (this.showCorporateBankExtras && this.singlePreviewRow) {
        const v = this.singlePreviewRow.bank_fullname
        this.bankHeadquartersPick = v != null && v !== '' ? String(v) : ''
        this.fetchBankCodeOptions(this.bankHeadquartersPick || '', true)
      } else {
        this.bankHeadquartersPick = ''
      }
    },
    fetchBankCodeOptions (query, immediate) {
      if (this.bankCodeSearchTimer) {
        clearTimeout(this.bankCodeSearchTimer)
        this.bankCodeSearchTimer = null
      }
      const run = () => {
        this.bankCodeLoading = true
        const q = query != null ? String(query).trim() : ''
        const params = { current_page: 1, per_page: 50 }
        if (q) {
          params.keyword = q
        }
        request('getPaymentCenterBankCode', params).then(({ data }) => {
          this.bankHeadquartersOptions = (data && data.data) ? data.data : []
        }).catch(() => {
          this.bankHeadquartersOptions = []
        }).finally(() => {
          this.bankCodeLoading = false
        })
      }
      if (immediate) {
        run()
      } else {
        this.bankCodeSearchTimer = setTimeout(run, 300)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.margin-b {
  margin-bottom: 16px;
}

.summary-block {
  padding: 12px 16px;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.summary-row--layout {
  align-items: flex-start;
  gap: 16px;
}

.summary-fields-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.summary-form-line {
  display: flex;
  align-items: center;
  gap: 12px;
}

.summary-label-fixed {
  flex-shrink: 0;
  width: 9em;
  text-align: right;
  line-height: 32px;
}

.summary-control-slot {
  width: 320px;
  flex-shrink: 0;
}

.summary-text-slot {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.summary-extra-value {
  font-size: 14px;
  color: #303133;
  line-height: 22px;
  word-break: break-all;
}

.summary-label-text {
  font-size: 16px;
  color: #606266;
}

.summary-account-select {
  width: 320px;
}

.summary-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #606266;
}

.summary-right--side {
  flex-shrink: 0;
  padding-top: 4px;
}

.summary-number {
  color: #f56c6c;
  font-weight: 600;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;

  .empty-icon {
    font-size: 64px;
    margin-bottom: 16px;
    color: #c0c4cc;
  }

  .empty-text {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payment-center/components/PaymentPayDialog.vue